module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }, [_c('v-card', {
    staticStyle: {
      "width": "900px"
    }
  }, [_c('v-card-title', [_c('h4', [_vm._v(_vm._s(_vm.isNew ? _vm.$t('crud.newTitle') : _vm.$t('crud.editTitle')))])]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "error": "",
      "value": !!_vm.error
    }
  }, [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), (_vm.refresh) ? _c('v-card-text', _vm._l((_vm.rows), function(row) {
    return _c('v-layout', {
      key: JSON.stringify(row),
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [(Array.isArray(row)) ? _vm._l((row), function(field) {
      return _c('v-flex', {
        key: field,
        staticClass: "pr-5",
        attrs: {
          "xs6": ""
        }
      }, [_c('crud-form-field', {
        ref: ("input_" + field),
        refInFor: true,
        attrs: {
          "options": _vm.fields[field],
          "field": field
        },
        model: {
          value: (_vm.value),
          callback: function($$v) {
            _vm.value = $$v
          },
          expression: "value"
        }
      })], 1)
    }) : [_c('v-flex', {
      staticClass: "pr-5"
    }, [_c('crud-form-field', {
      ref: ("input_" + row),
      refInFor: true,
      attrs: {
        "options": _vm.fields[row],
        "field": row
      },
      model: {
        value: (_vm.value),
        callback: function($$v) {
          _vm.value = $$v
        },
        expression: "value"
      }
    })], 1)]], 2)
  })) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    staticClass: "elevation-0",
    attrs: {
      "type": "submit",
      "success": "",
      "loading": _vm.isBusy
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "left": ""
    }
  }, [_vm._v("save")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.isNew ? _vm.$t('create') : _vm.$t('save')))])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "elevation-0",
    attrs: {
      "error": "",
      "loading": _vm.isBusy
    },
    on: {
      "click": _vm.cancel
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "left": ""
    }
  }, [_vm._v("clear")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('cancel')))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c7e64780","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Crud/CrudForm.vue
// module id = 1100
// module chunks = 1